import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type BellOffIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const BellOffIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: BellOffIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Bell off'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M10.3 21a1.94 1.94 0 0 0 3.4 0'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <line
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        x1='2'
        x2='22'
        y1='2'
        y2='22'
      />
    </svg>
  )
}
